module.exports = __webpack_public_path__ + "static/media/payment_link_preview.857cf46a.PNG";